import React, { useEffect, useState } from "react";
import { Translator } from './translator';
import { Mic, CalendarDays, Gamepad2, NotebookPen, Palette, Heart, Building2, Wine } from "lucide-react";

const Eventi = () => {
    const { translateText, lang } = Translator();

    const baseText = {
        text1: "Game",
        text2: "Vita notturna",
        text3: "Arti sceniche e visive",
        text4: "Festività",
        text5: "Appuntamenti",
        text6: "Hobby",
        text7: "Affari",
        text8: "Enogastronomia",
        text9: "Eventi a Campania",
        text10: "Festa dei Gigli",
        text11: "20 e 21 giugno: Gigli Spogliati",
        text12: "22 giugno: Processione di San Paolino",
        text13: "29 giugno: ballata dei Gigli",
        text14: "Festa della Madonna di Campanile",
        text15: "dal 30 Agosto 2024 al 08 Settembre 2024",
        text16: "Fiera d’Agosto",
        text17: "dal 14 Agosto 2025 al 14 Agosto 2025",
        text18: "per chi adora beni culturali!",




    };

    const [translatedText, setTranslatedText] = useState(baseText);
    useEffect(() => {
    const translateAll = async () => {
        const entries = Object.entries(baseText);
        const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => [key, await translateText(value)])
        );
        setTranslatedText(Object.fromEntries(translatedEntries));
    };

    translateAll();
    }, [lang]);


    const categories = [
        { icon: <Mic className="w-6 h-6" />, label: translatedText.text1 },
        { icon: <CalendarDays className="w-6 h-6" />, label: translatedText.text2 },
        { icon: <Palette className="w-6 h-6" />, label: translatedText.text3 },
        { icon: <NotebookPen className="w-6 h-6" />, label: translatedText.text4 },
        { icon: <Heart className="w-6 h-6" />, label: translatedText.text5 },
        { icon: <Gamepad2 className="w-6 h-6" />, label: translatedText.text6 },
        { icon: <Building2 className="w-6 h-6" />, label: translatedText.text7 },
        { icon: <Wine className="w-6 h-6" />, label: translatedText.text8 },
      ];

      const eventi = [
    {
      title: translatedText.text10,
      subtitle: (
            <>
              • {translatedText.text11}<br />
              • {translatedText.text12}<br />
              • {translatedText.text13}
            </>
          ),
      image: "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/eventi/Gigli_di_Nola.jpg",
    },
    {
      title: translatedText.text14,
      subtitle: translatedText.text15,
      image: "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/eventi/evento2.png",
    },
    {
      title: translatedText.text16,
      subtitle: translatedText.text17,
      image: "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/eventi/evento3.jpg",
    },
  ];

  return (
    <div className="bg-white py-10 px-6 min-h-screen">
    {/* INTRO SECTION */}
    <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-16">
      {/* Text */}
      <div className="md:w-1/2 space-y-4">
        <h2 className="text-4xl font-bold text-black">Te.c.H-e</h2>
        <h1 className="text-4xl md:text-4xl font-extrabold text-black">{translatedText.text18}</h1>
      </div>
      {/* Image */}
      <div className="md:w-1/2 rounded-xl overflow-hidden shadow-lg">
        <img
          src="https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/Eventi/intro.png"
          alt="Superorganism al Great American Music Hall"
          className="w-full h-64 object-cover"
        />
      </div>
    </div>

    {/* CATEGORIES */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 justify-items-center mb-16">
      {categories.map((cat, index) => (
        <div
          key={index}
          className="flex flex-col items-center justify-center text-center p-4 border rounded-full w-28 h-28 text-sm text-black hover:bg-purple-100 transition"
        >
          {cat.icon}
          <span className="mt-2">{cat.label}</span>
        </div>
      ))}
    </div>

    
      <h1 className="text-4xl font-bold text-center text-black mb-12">{translatedText.text9}</h1>
      
      <div className="grid md:grid-cols-3 gap-8">
        {eventi.map((event, index) => (
          <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <img src={event.image} alt={event.title} className="w-full h-60 object-cover" />
            <div className="p-6">
              <h2 className="text-xl font-semibold text-black mb-2">{event.title}</h2>
              <p className="text-black text-sm">{event.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Eventi;
